import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import TitleIcon from 'core/layouts/title-icon'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col, Empty } from 'core/components/ui'
//import PageLoading from 'core/components/page-loading'

import { configuratorShape } from '../shapes'
import FundingCard from './funding-card'

/******** ws */
const initialFundingList = [
  {
    label: 'Crédit classique',
    description:
      "Il s'agit d'un emprunt affecté exclusivement à un projet automobile qui vous est proposé par notre société interne de financement",
    bring: 0,
    maxStep: 48,
    minStep: 12,
    step: 6,
    monthly: 18,
    price: 328
  },
  {
    label: "Location avec option d'achat",
    description:
      "C'est une formule souple vous permettant de louer votre véhicule de 12 à 60 mois en bénéficiant d'une garantie et vous permettant d'acheter - ou non - votre véhicule au terme du contrat",
    bring: 0,
    maxStep: 48,
    minStep: 12,
    step: 6,
    monthly: 6,
    price: 425
  },
  {
    label: "Location avec option d'achat longue durée",
    description:
      "Il s'agit d'un contrat de location sur une durée de 12 à 60 mois, adaptée aux besoins des entreprises. Vous bénéficiez de services enrichis et ne vous préoccupez pas de la revente de votre véhicule",
    bring: 0,
    maxStep: 60,
    minStep: 12,
    step: 6,
    monthly: 24,
    price: 5385
  }
]
/************** */

const StyledTitleIcon = styled(TitleIcon)`
  margin-bottom: 25px;
`

const Funding = props => {
  const { configurator, setConfigurator, intl, setWizards, wizards, history } = props
  const { fundingList } = configurator

  const renderList = () =>
    fundingList.map(item => (
      <Col lg={8} xs={24} key={item.label}>
        <FundingCard item={item} />
      </Col>
    ))

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FUNDING) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_FUNDING
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    // else load datas

    // SetTimout to fake loading
    setTimeout(() => {
      setConfigurator({
        ...configurator,
        fundingList: initialFundingList
      })
    }, 1000)
    activateNextStep()
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-funding-view-title' })}
      data-test="component-configurator-funding-funding"
    >
      <StyledTitleIcon
        title={intl.formatMessage({
          id: 'configurator-funding-view-title-2'
        })}
      />

      {fundingList ? (
        <Row gutter={30} data-test="configurator-funding-funding-fundingWrapper">
          {renderList()}
        </Row>
      ) : (
        <Empty />
      )}
    </MainContentWrapper>
  )
}

Funding.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(Funding))
